export const ACTIONS = {
  REQUEST_EMPLOYER_DISCOUNTS: 'REQUEST_EMPLOYER_DISCOUNTS',
  RECEIVE_EMPLOYER_DISCOUNTS: 'RECEIVE_EMPLOYER_DISCOUNTS',
  RECEIVE_EMPLOYER_DISCOUNTS_ERROR: 'RECEIVE_EMPLOYER_DISCOUNTS_ERROR',
  REQUEST_EMP_BENEFIT_INFO: 'REQUEST_EMP_BENEFIT_INFO',
  RECEIVE_EMP_BENEFIT_INFO: 'RECEIVE_EMP_BENEFIT_INFO',
  REQUEST_EMP_BENEFIT_INFO_ERROR: 'REQUEST_EMP_BENEFIT_INFO_ERROR',
};
export default ACTIONS;
